// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/plex_metadata.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { NumberFormatType } from "./number_format_type_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_number_format_type } from "./number_format_type_pb";
import type { UnitScale } from "./unit_scale_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_unit_scale } from "./unit_scale_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/plex_metadata.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_plex_metadata: GenFile = /*@__PURE__*/
  fileDesc("CjtxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvcGxleF9tZXRhZGF0YS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIvYECgxQbGV4TWV0YWRhdGESHAoHcGxleF9pZBgBIAEoCUIGgrUYAhgBSACIAQESGAoLcGxleF9yZWdpb24YAiABKAlIAYgBARIWCglwbGV4X25hbWUYAyABKAlIAogBARIdCghhc3NheV9pZBgEIAEoCUIGgrUYAhgBSAOIAQESFgoOY2FsaWJyYXRvcl9pZHMYBSADKAkSEwoLY29udHJvbF9pZHMYBiADKAkSHAoPYXNzYXlfbGltaXRzX2lkGAcgASgJSASIAQESSwoKbWFzc19zY2FsZRgIIAEoDjIyLnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5Vbml0U2NhbGVIBYgBARJNCgx2b2x1bWVfc2NhbGUYCSABKA4yMi5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuVW5pdFNjYWxlSAaIAQESWgoSbnVtYmVyX2Zvcm1hdF90eXBlGAogASgOMjkucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLk51bWJlckZvcm1hdFR5cGVIB4gBARIdChBudW1iZXJfb2ZfZGlnaXRzGAsgASgFSAiIAQFCCgoIX3BsZXhfaWRCDgoMX3BsZXhfcmVnaW9uQgwKCl9wbGV4X25hbWVCCwoJX2Fzc2F5X2lkQhIKEF9hc3NheV9saW1pdHNfaWRCDQoLX21hc3Nfc2NhbGVCDwoNX3ZvbHVtZV9zY2FsZUIVChNfbnVtYmVyX2Zvcm1hdF90eXBlQhMKEV9udW1iZXJfb2ZfZGlnaXRzYgZwcm90bzM", [file_quanterix_common_extensions_v1_field_options, file_quanterix_simoa_one_analysis_app_api_v1_number_format_type, file_quanterix_simoa_one_analysis_app_api_v1_unit_scale]);

/**
 * Contains metadata describing a plex (analyte) within an assay
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.PlexMetadata
 */
export type PlexMetadata = Message<"quanterix.simoa_one.analysis_app_api.v1.PlexMetadata"> & {
  /**
   * Unique identifier for the plex (UUID)
   *
   * @generated from field: optional string plex_id = 1;
   */
  plexId?: string;

  /**
   * Represents the plex classification region for analysis,
   * also referred to as a plex "barcode"
   *
   * @generated from field: optional string plex_region = 2;
   */
  plexRegion?: string;

  /**
   * User-friendly name
   *
   * @generated from field: optional string plex_name = 3;
   */
  plexName?: string;

  /**
   * Unique identifier (UUID) for the parent assay of this plex
   *
   * @generated from field: optional string assay_id = 4;
   */
  assayId?: string;

  /**
   * Unique identifiers (UUID) for calibrators referenced by this plex
   *
   * @generated from field: repeated string calibrator_ids = 5;
   */
  calibratorIds: string[];

  /**
   * Unique identifiers (UUID) for controls referenced by this plex
   *
   * @generated from field: repeated string control_ids = 6;
   */
  controlIds: string[];

  /**
   * Unique identifier (UUID) for data quality and acceptance criteria limits
   *  referenced by this plex
   *
   * @generated from field: optional string assay_limits_id = 7;
   */
  assayLimitsId?: string;

  /**
   * Mass unit scale, using gram (g) as the baseline unit
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.UnitScale mass_scale = 8;
   */
  massScale?: UnitScale;

  /**
   * Volume unit scale, using liter (L) as the baseline unit
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.UnitScale volume_scale = 9;
   */
  volumeScale?: UnitScale;

  /**
   * Format type for representing concentration values as a strings
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.NumberFormatType number_format_type = 10;
   */
  numberFormatType?: NumberFormatType;

  /**
   * Number of digits for the string representation of the value,
   * combined with number_format_type
   *
   * @generated from field: optional int32 number_of_digits = 11;
   */
  numberOfDigits?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.PlexMetadata.
 * Use `create(PlexMetadataSchema)` to create a new message.
 */
export const PlexMetadataSchema: GenMessage<PlexMetadata> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_plex_metadata, 0);

